var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpiredDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.868,
    height: 35.5,
    viewBox: "0 0 42.868 35.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User_new",
    "data-name": "User new",
    transform: "translate(0.25 -42.416)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24247",
    "data-name": "Path 24247",
    d: "M20.335,59.84a9.242,9.242,0,0,0,4.5-7.963,9.055,9.055,0,0,0-8.868-9.211,9.055,9.055,0,0,0-8.868,9.211,9.242,9.242,0,0,0,4.5,7.963A15.38,15.38,0,0,0,0,74.483v2.262a.9.9,0,0,0,.887.921.9.9,0,0,0,.887-.921V74.483c0-7.385,6.366-13.4,14.189-13.4s14.19,6.011,14.19,13.4v2.262a.888.888,0,1,0,1.774,0V74.483A15.378,15.378,0,0,0,20.335,59.84ZM8.868,51.877a7.243,7.243,0,0,1,7.095-7.368,7.374,7.374,0,0,1,0,14.737,7.243,7.243,0,0,1-7.095-7.368Z",
    transform: "translate(0 0)",
    fill: "#e220a1",
    stroke: "#e220a1",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24248",
    "data-name": "Path 24248",
    d: "M336.3,98.366a6.907,6.907,0,0,0,3.763-5.926c0-3.919-3.747-7.106-8.354-7.106a.9.9,0,1,0,0,1.776c3.454,0,6.265,2.391,6.265,5.329s-2.811,5.329-6.265,5.329a.9.9,0,1,0,0,1.776c6.911,0,12.53,4.418,12.53,9.85v1.7a1.058,1.058,0,0,0,2.088,0v-1.7C346.33,104.262,342.12,99.9,336.3,98.366Z",
    transform: "translate(-303.962 -38.491)",
    fill: "#e220a1",
    stroke: "#e220a1",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiredDocuments);
export default __webpack_public_path__ + "static/media/expiredDocuments.daa57502cc411a7451b763a563d6d529.svg";
export { ForwardRef as ReactComponent };